module.exports = "<legend >\r\n    <span>{{ label ? label : \"  \" | translate }}</span>\r\n</legend>"